var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCodeCloseTag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.966,
    height: 16.151,
    viewBox: "0 0 22.966 16.151",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .closeTagA {\n                fill: #2196c9;\n            }\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6.053 -17.739)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "closeTagA",
    d: "M7.4,32.85l5.57-3.719a.529.529,0,0,0-.587-.879l-5.57,3.719a1.707,1.707,0,0,0,0,2.839l5.57,3.719a.529.529,0,1,0,.587-.879L7.4,33.93a.649.649,0,0,1,0-1.08Z",
    transform: "translate(0 -7.668)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "closeTagA",
    d: "M72.283,31.971l-5.57-3.719a.529.529,0,1,0-.587.879L71.7,32.85a.649.649,0,0,1,0,1.08L66.126,37.65a.529.529,0,1,0,.587.879l5.57-3.719a1.707,1.707,0,0,0,0-2.839Z",
    transform: "translate(-44.023 -7.669)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "closeTagA",
    d: "M43.892,17.764a.529.529,0,0,0-.664.343L38.411,33.2a.528.528,0,1,0,1.007.321l4.817-15.094A.529.529,0,0,0,43.892,17.764Z",
    transform: "translate(-23.787 0)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeCloseTag);
export default __webpack_public_path__ + "static/media/code-close-tag.e10a4dec.svg";
export { ForwardRef as ReactComponent };